import { createSlice } from "@reduxjs/toolkit";
import { getLanguage, getMenuData, getNotifications, setBrandPath, setClientPath, setMarketPath } from "./thunk";

const initialState = {
  client: null,
  language: null,
  error: null,
  errorMsg: null,
  locationHook: null,
  clientPath: undefined,
  brandPath: undefined,
  marketPath: undefined,
  folderPath: null,
  campaignPath: null,
  versionPath: null,
  pageTitle: null,
  title: [],
  notifications: [],
  unseenNotifications: 0,
  analyticsMenubar: null,
};

const menuSlice = createSlice({
  name: "MenuData",
  initialState,
  reducers: {
    /* eslint-disable require-jsdoc */
    setMenuData(state, action) {
      state.client = action.payload;
    },
    setLanguage(state, action) {
      state.language = action.payload;
    },
    setMenuDataError(state, action) {
      state.error = true;
      state.errorMsg = action.payload;
    },
    setLocationHook(state, action) {
      state.locationHook = action.payload;
    },
    setClientPath(state, action) {
      state.clientPath = action.payload;
    },
    setBrandPath(state, action) {
      state.brandPath = action.payload;
    },
    setMarketPath(state, action) {
      state.marketPath = action.payload;
    },
    setFolderPath(state, action) {
      state.folderPath = action.payload;
    },
    setCampaignPath(state, action) {
      state.campaignPath = action.payload;
    },
    setVersionPath(state, action) {
      state.versionPath = action.payload;
    },
    setBreadcrumb(state, action) {
      state.pageTitle = action.payload.pageTitle;
      state.title = action.payload.title;
    },
    setUnseenNotifications(state, action) {
      state.unseenNotifications = action.payload;
    },
    setAnalyticsMenubar(state, action) {
      state.analyticsMenubar = action.payload;
    },
    resetMenuDataState(state) {
      state.client= null;
      state.error= null;
      state.errorMsg= null;
      state.locationHook= null;
      state.clientPath= undefined;
      state.brandPath= undefined;
      state.marketPath= undefined;
      state.folderPath= null;
      state.campaignPath= null;
      state.versionPath= null;
      state.pageTitle = null;
      state.title = [];
      state.notifications = [];
      state.unseenNotifications = 0;
      state.analyticsMenubar = null;
    },
    /* eslint-enable require-jsdoc */
  },
  // extraReducers: (builder) => {
  //   builder.addCase(getMenuData.fulfilled, (state, action) => {
  //     state.client = action.payload;
  //   })
  // }
  extraReducers: (builder) => {
    builder.addCase(getLanguage.fulfilled, (state, action) => {
      state.language = action.payload;
    }),
    builder.addCase(setClientPath.fulfilled, (state, action) => {
      state.clientPath = action.payload;
    }),
    builder.addCase(setBrandPath.fulfilled, (state, action) => {
      state.brandPath = action.payload;
    }),
    builder.addCase(setMarketPath.fulfilled, (state, action) => {
      state.marketPath = action.payload;
    }),
    builder.addCase(getNotifications.fulfilled, (state, action) => {
      state.notifications = action.payload;
      let unseenNotifications = action.payload.filter(item => !item.hasOwnProperty('readen'));
      state.unseenNotifications = unseenNotifications.length;
    })
  }
})

export const {
  setMenuData,
  setMenuDataError,
  // setClientPath,
  // setBrandPath,
  // setMarketPath,
  setLocationHook,
  setFolderPath,
  setCampaignPath,
  setVersionPath,
  setBreadcrumb,
  setUnseenNotifications,
  setAnalyticsMenubar,
  resetMenuDataState
} = menuSlice.actions;

export default menuSlice.reducer;